module.exports = "/_next/static/images/DataCentersCapabilitiesHero-fc6bd9a2aa419808fb184b69f0ad4f27.webp";